import React from "react";

const Rank = () => {
    return (
        <div>
            <div className='black f3'>
                {'Joeban, your current rank of useage is...'}
            </div>
            <div className='black f1'>
                {'#5'}
            </div>
        </div>
    )
}

export default Rank;